export default __webpack_public_path__ + "static/media/bad-website-3.2ee6ca46.png";